// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"552":"transactions","596":"subscription","768":"portfolio-details","884":"admin","945":"dashboard"}[chunkId] || chunkId) + "." + {"10":"3b94611a","219":"9f5c9dce","552":"eb402a56","596":"e4609021","768":"b85ac33f","884":"e620c6f4","945":"583a7264"}[chunkId] + ".js";
};